import { jsx as _jsx } from "react/jsx-runtime";
import { AppIcon, Box, IconButton, styled } from '@streem/ui-react';
export const CloseButton = (props) => (_jsx(Box, { style: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        right: `28px`,
        top: `28px`,
    }, children: _jsx(IconButton, { iconName: "CloseIcon", size: "medium", shape: "circle", label: "close", onClick: props.onClick, background: "azure", fill: "white", "data-testid": props.id, type: "button" }) }));
export const CallDetailsIcon = styled(AppIcon)(() => ({
    transform: 'scale(0.9)',
    flexShrink: 0,
}));
//# sourceMappingURL=tool_styles.js.map